let GoogleMaps = (function () {
    let getPlaceID = function (lat, lng, key) {
        let url = `https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=${lat},${lng}&radius=1,&key=${key}`;
        fetch(url)
            .then(function (response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                        response.status);
                    return;
                }

                response.json().then(function (data) {
                    console.log(data);
                });
            })
            .catch(function (err) {
                console.log('Fetch Error :', err);
            });
    }

    return {
        getPlaceID: getPlaceID,
    }
})();